
<script>
import New from './New4'
import Edit from '../Edit'
export default {
  mixins: [New, Edit]
}
</script>
